import { Modal, ModalContent } from '@chakra-ui/react';
import { useSnackbar } from '@components/snackbar';
import { StandardSnack } from '@sketch-note/design-system/src/components/snackbar';
import { ErrorIcon } from '@sketchnote/icons';
import cn from 'classnames';
import React, { useEffect, useState } from 'react';

import { useTasksStore } from '../../store/useTasksStore';
import { Task } from '../../types/tasks';

export const EmailFieldComponent = ({
  task,
  fieldId,
  data,
  disabled,
}: {
  task: Partial<Task>;
  fieldId: string;
  label: string;
  data: string;
  handleDelete: (flag: boolean) => void;
  disabled?: boolean;
}): JSX.Element => {
  const [fieldData, setFieldData] = useState(typeof data === 'string' ? data : '');
  const [isFocused, setIsFocused] = useState(false);
  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
  const [open] = useSnackbar();

  const onUpdateCustomFieldData = useTasksStore((s) => s.onUpdateCustomFieldData);
  const onUpdateCustomTemplateFieldData = useTasksStore((s) => s.onUpdateCustomTemplateFieldData);

  useEffect(() => {
    setFieldData(typeof data === 'string' ? data : '');
  }, [data]);

  const handleErrorModal = () => {
    setErrorModalIsOpen(false);
    setIsFocused(true);
  };
  const testEmail = (inputStr): boolean => {
    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailPattern.test(inputStr);
  };

  const handleUpdateFieldData = async () => {
    if (testEmail(fieldData)) {
      setIsFocused(false);
      if (task.id) {
        const payload = { taskId: task.id, fieldId: fieldId, data: fieldData };
        let success = false;
        if (task.board?.id === undefined) {
          payload['taskTemplateRef'] = task.id;
          success = await onUpdateCustomTemplateFieldData(payload);
        } else {
          payload['taskTemplateRef'] = undefined;
          success = await onUpdateCustomFieldData(payload);
        }
        if (!success) {
          open({
            text: 'Failed to update field data',
            snackType: 'error',
            position: 'top-center',
            duration: 3000,
          });
        }
      }
    } else {
      setFieldData('');
      setErrorModalIsOpen(true);
      setIsFocused(false);
    }
  };

  return (
    <>
      <input
        readOnly={disabled}
        type="text"
        placeholder="Add email"
        pattern="[^ @]*@[^ @]*"
        className={cn('text-sm text-gray-999 font-regular placeholder-gray-500 h-36 w-400 pl-15', {
          'bg-white rounded-sm border border-gray-200': isFocused,
        })}
        onChange={(e) => {
          setFieldData(e.target.value);
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            if (testEmail(fieldData)) {
              // setFieldData(fieldData);
              setIsFocused(false);
              if (task.id) {
                const payload = { taskId: task.id, fieldId: fieldId, data: fieldData };
                if (task.board?.id === undefined) {
                  payload['taskTemplateRef'] = task.id;
                  onUpdateCustomTemplateFieldData(payload);
                } else {
                  payload['taskTemplateRef'] = undefined;
                  onUpdateCustomFieldData(payload);
                }
              }
            } else {
              setFieldData('');
              setErrorModalIsOpen(true);
            }
          }
        }}
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={handleUpdateFieldData}
        value={fieldData}
      />
      <Modal isOpen={errorModalIsOpen} onClose={handleErrorModal}>
        <ModalContent style={{ width: '40rem', borderRadius: '10px', marginTop: '65rem' }}>
          <StandardSnack icon={<ErrorIcon />} text="Enter valid email" />
        </ModalContent>
      </Modal>
    </>
  );
};
